import React from 'react'

import Video from 'components/Video/Video'
import useResponsive from 'hooks/useResponsive'

export default function CmsPageHeaderVideo({ pageHeader }) {
  const { isMobile } = useResponsive()

  const src = isMobile
    ? pageHeader.videoBackgroundMobile?.url
    : pageHeader.videoBackgroundDesktop?.url

  const posterSrc = isMobile
    ? pageHeader.imageBackgroundMobile?.url
    : pageHeader.imageBackgroundDesktop?.url

  // Key attr is needed to trigger re-rendering
  return (
    <Video
      id="videoBg"
      src={src}
      poster={posterSrc}
      autoPlay
      muted
      loop
      playsInline
      key={src}
    />
  )
}
